export const createAccountInitialValues = {
  raisonSociale: "",
  payId: "",
  email: "",
  telephone: "",
  acceptPolicy: false
};
